import Button from 'core/modules/atoms/Button';
import Textarea from 'core/modules/atoms/Textarea';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

const TextInputMode = ({ error, value, onChange, placeholder, wordCount, wordLimit, onOpenDialog, disabled, name }) => {
  const { t } = useTranslation(['chatbot']);
  const handleChange = (e) => {
    onChange(e.currentTarget.value);
  };

  return (
    <div className={`text-input-mode ${error ? 'text-input-mode--error' : ''}`}>
      <div className="text-input-mode__textarea-wrapper">
        <Textarea name={name} placeholder={placeholder} onChange={handleChange} value={value} rows={2} disabled={disabled} />
      </div>

      <div className="text-input-mode__footer">
        <div>
          <Button
            text={t('chatbot:Choose from book')}
            size="large"
            color="transparent-primary"
            onClick={onOpenDialog}
            disabled={disabled}
            variant="inline"
            className="text-input-mode__choose-button"
          />
        </div>

        <div className="text-input-mode__counter">
          {t('chatbot:Word limit')}: {wordCount}/{wordLimit}
        </div>
      </div>
    </div>
  );
};

TextInputMode.propTypes = {
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onOpenDialog: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.string.isRequired,
  wordCount: PropTypes.number.isRequired,
  wordLimit: PropTypes.number.isRequired,
};

TextInputMode.defaultProps = {
  disabled: false,
  error: false,
  name: 'text-input',
  placeholder: '',
  wordLimit: 2000,
};

export default TextInputMode;
